// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__39R7Q","colMaxWidth":"Table_colMaxWidth__HDmBp"};